// // // src/components/AnalysisSelectModal.jsx
// // // 3-step modal before resume generation:
// // // Step 1 — Select analysis (skip if only 1)
// // // Step 2 — Confirm resume text (extra details like skills filled on ResumeGeneratorPage)
// // // Step 3 — Choose template
// // // → navigates to /generate-resume with all data

// // import { useState, useRef } from "react";
// // import { useNavigate } from "react-router-dom";
// // import servicesConfig from "../utils/servicesConfig";

// // import { extractFileText } from "../utils/extractFileText";

// // import TemplateMini from "../components/TemplateMini";

// // // ── Template card using shared TemplateMini ──
// // function TemplateCard({ template, selected, onSelect }) {
// //   const { accent } = template;
// //   return (
// //     <div
// //       onClick={() => onSelect(template.id)}
// //       style={{
// //         borderRadius: 12, border: selected ? `2px solid ${accent}` : "1.5px solid #e2e8f0",
// //         background: "#fff", cursor: "pointer", transition: "all 0.2s",
// //         overflow: "hidden", position: "relative",
// //         boxShadow: selected ? `0 6px 20px ${accent}28` : "0 1px 4px rgba(0,0,0,0.04)",
// //         transform: selected ? "translateY(-2px) scale(1.01)" : "none",
// //       }}
// //       onMouseEnter={e => { if (!selected) { e.currentTarget.style.borderColor = accent; e.currentTarget.style.transform = "translateY(-1px)"; } }}
// //       onMouseLeave={e => { if (!selected) { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; } }}
// //     >
// //       {selected && (
// //         <div style={{ position: "absolute", top: 6, right: 6, background: accent, color: "#fff", fontSize: 9, fontWeight: 700, padding: "1px 7px", borderRadius: 20, zIndex: 3 }}>✓ Selected</div>
// //       )}
// //       {/* Accurate mini preview */}
// //       <div style={{ background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px 8px 4px" }}>
// //         <TemplateMini t={template} scale={0.25} width={600} />
// //       </div>
// //       <div style={{ padding: "7px 10px 9px", borderTop: "1px solid #f1f5f9" }}>
// //         <div style={{ fontWeight: 700, fontSize: 12, color: "#0f172a", marginBottom: 1 }}>{template.name}</div>
// //         <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, lineHeight: 1.4 }}>{template.description}</div>
// //         <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
// //           {template.tags.map(t => <span key={t} style={{ fontSize: 9, padding: "1px 5px", borderRadius: 20, background: `${accent}12`, color: accent, fontWeight: 600 }}>{t}</span>)}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default function AnalysisSelectModal({ analyses, transactionId, planId, onClose, userData }) {
// //   const navigate  = useNavigate();
// //   const fileRef   = useRef();

// //   // ── Step state ──
// //   const totalSteps = analyses.length > 1 ? 3 : 2; // skip step 1 if only 1 analysis
// //   const [step, setStep] = useState(analyses.length > 1 ? 1 : 2);

// //   // ── Step 1: Analysis selection ──
// //   const [selectedAnalysisId, setSelectedAnalysisId] = useState(analyses[0]?.id || null);

// //   // ── Step 2: Resume + extra details ──
// //   const selectedAnalysis = analyses.find(a => a.id === selectedAnalysisId) || analyses[0];
// //   const [resumeText, setResumeText]       = useState(selectedAnalysis?.resumeText || "");
// //   const [resumeFileName, setResumeFileName] = useState("");
// //   const [uploadMode, setUploadMode]       = useState(resumeText ? "paste" : "upload");
// //   const [fileError, setFileError]         = useState("");

// //   // ── Step 3: Template selection ──
// //   // Templates strictly from plan's resumeTemplateIds — never shows all
// //   const planConfig = servicesConfig.plans.find(p => p.id === planId);
// //   const templates = (() => {
// //     if (planConfig?.resumeTemplateIds?.length > 0) {
// //       return servicesConfig.resumeTemplates.filter(t =>
// //         t.active &&
// //         !t.comingSoon &&
// //         planConfig.resumeTemplateIds.includes(t.id)
// //       );
// //     }
// //     // Hard fallback to ats_basic only
// //     const basicPlan = servicesConfig.plans.find(p => p.id === "ats_basic");
// //     return servicesConfig.resumeTemplates.filter(t =>
// //       t.active && !t.comingSoon && (basicPlan?.resumeTemplateIds || []).includes(t.id)
// //     );
// //   })();
// //   const [selectedTemplate, setSelectedTemplate] = useState("classic");

// //   const activeTemplate = templates.find(t => t.id === selectedTemplate) || templates[0];

// //   async function handleFileUpload(e) {
// //     const file = e.target.files[0];
// //     if (!file) return;
// //     setFileError("");
// //     try {
// //       const text = await extractFileText(file);
// //       if (!text || text.length < 50) { setFileError("Could not extract text. Try pasting instead."); return; }
// //       setResumeText(text);
// //       setResumeFileName(file.name);
// //     } catch (err) {
// //       setFileError(err.message || "Could not read file.");
// //     }
// //   }

// //   function fmtDate(ts) {
// //     if (!ts) return "";
// //     const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
// //     return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
// //   }

// //   function handleGenerate() {
// //     if (!resumeText.trim()) return;
// //     onClose();
// //     navigate("/generate-resume", {
// //       state: {
// //         resumeText,
// //         jobDescription:  selectedAnalysis?.jobDescription || "",
// //         analysisResult:  selectedAnalysis,
// //         templateId:      selectedTemplate,
// //         transactionId,
// //         fromDashboard:   true,

// //       },
// //     });
// //   }

// //   // Step labels
// //   const stepLabels = analyses.length > 1
// //     ? ["Select Analysis", "Your Resume", "Choose Template"]
// //     : ["Your Resume", "Choose Template"];

// //   const currentStepIndex = analyses.length > 1 ? step - 1 : step - 2;

// //   return (
// //     <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(15,23,42,0.78)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
// //       <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 700, maxHeight: "92vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 60px rgba(0,0,0,0.3)", animation: "fadeIn 0.25s ease" }}>

// //         {/* ── Header ── */}
// //         <div style={{ padding: "20px 24px 0", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
// //           <div>
// //             <h2 style={{ fontSize: 18, fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.01em" }}>
// //               {step === 1 ? "📊 Select Best Analysis" : step === 2 ? "📄 Your Resume & Details" : "🎨 Choose Template"}
// //             </h2>
// //             <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
// //               {step === 1 ? "Pick the analysis you're most satisfied with"
// //                 : step === 2 ? "Upload or confirm your resume — the AI will use this as the base for improvement"
// //                 : "Select the layout style for your improved resume"}
// //             </p>
// //           </div>
// //           <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b", flexShrink: 0, marginLeft: 12 }}>×</button>
// //         </div>

// //         {/* ── Step indicator ── */}
// //         <div style={{ padding: "14px 24px 0", display: "flex", alignItems: "center", gap: 6 }}>
// //           {stepLabels.map((label, i) => (
// //             <div key={i} style={{ display: "flex", alignItems: "center", gap: 6 }}>
// //               <div style={{ width: 26, height: 26, borderRadius: "50%", background: currentStepIndex > i ? "linear-gradient(135deg,#059669,#047857)" : currentStepIndex === i ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#f1f5f9", color: currentStepIndex >= i ? "#fff" : "#94a3b8", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s", flexShrink: 0 }}>
// //                 {currentStepIndex > i ? "✓" : i + 1}
// //               </div>
// //               <span style={{ fontSize: 12, fontWeight: 600, color: currentStepIndex === i ? "#0f172a" : "#94a3b8", whiteSpace: "nowrap" }}>{label}</span>
// //               {i < stepLabels.length - 1 && <div style={{ width: 24, height: 1.5, background: currentStepIndex > i ? "#059669" : "#e2e8f0", margin: "0 4px", transition: "all 0.3s" }} />}
// //             </div>
// //           ))}
// //         </div>

// //         <div style={{ height: 1, background: "#f1f5f9", margin: "14px 0 0" }} />

// //         {/* ── Scrollable body ── */}
// //         <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>

// //           {/* ════ STEP 1: Select Analysis ════ */}
// //           {step === 1 && (
// //             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
// //               {analyses.map((a, idx) => {
// //                 const score      = a.ats_score || 0;
// //                 const scoreColor = score >= 75 ? "#059669" : score >= 50 ? "#d97706" : "#dc2626";
// //                 const scoreBg    = score >= 75 ? "#f0fdf4" : score >= 50 ? "#fffbeb" : "#fef2f2";
// //                 const isSelected = selectedAnalysisId === a.id;
// //                 return (
// //                   <div key={a.id} onClick={() => setSelectedAnalysisId(a.id)}
// //                     style={{ borderRadius: 14, border: isSelected ? "2px solid #2563eb" : "1.5px solid #e2e8f0", background: isSelected ? "#f0f7ff" : "#fff", cursor: "pointer", padding: "16px 18px", transition: "all 0.2s", boxShadow: isSelected ? "0 4px 16px rgba(37,99,235,0.12)" : "none" }}
// //                     onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor = "#93c5fd"; }}
// //                     onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor = "#e2e8f0"; }}
// //                   >
// //                     <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
// //                       <div style={{ background: scoreBg, borderRadius: 10, padding: "8px 14px", textAlign: "center", minWidth: 68, flexShrink: 0 }}>
// //                         <div style={{ fontSize: 9, fontWeight: 700, color: scoreColor, textTransform: "uppercase", letterSpacing: "0.06em" }}>Score</div>
// //                         <div style={{ fontSize: 24, fontWeight: 900, color: scoreColor, lineHeight: 1 }}>{score}</div>
// //                       </div>
// //                       <div style={{ flex: 1, minWidth: 0 }}>
// //                         <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
// //                           <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>Analysis #{analyses.length - idx}</span>
// //                           {isSelected && <span style={{ fontSize: 10, background: "#2563eb", color: "#fff", padding: "1px 8px", borderRadius: 20, fontWeight: 700 }}>✓ Selected</span>}
// //                           {idx === 0 && <span style={{ fontSize: 10, background: "#f0fdf4", color: "#059669", padding: "1px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #bbf7d0" }}>Most Recent</span>}
// //                           <span style={{ fontSize: 11, color: "#94a3b8" }}>{fmtDate(a.createdAt)}</span>
// //                         </div>
// //                         <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
// //                           <span style={{ fontSize: 12, color: "#475569" }}>Match: <strong style={{ color: "#0f172a" }}>{a.match_rate || 0}%</strong></span>
// //                           <span style={{ fontSize: 12, color: "#475569" }}>Missing: <strong style={{ color: "#dc2626" }}>{a.missing_count || 0}</strong> keywords</span>
// //                         </div>
// //                         {a.missing_keywords?.length > 0 && (
// //                           <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6 }}>
// //                             {a.missing_keywords.slice(0, 5).map(k => <span key={k} style={{ fontSize: 10, background: "#fef2f2", color: "#dc2626", padding: "1px 7px", borderRadius: 20, fontWeight: 600 }}>{k}</span>)}
// //                             {a.missing_keywords.length > 5 && <span style={{ fontSize: 10, color: "#94a3b8" }}>+{a.missing_keywords.length - 5} more</span>}
// //                           </div>
// //                         )}
// //                       </div>
// //                       <div style={{ width: 22, height: 22, borderRadius: "50%", border: `2px solid ${isSelected ? "#2563eb" : "#cbd5e1"}`, background: isSelected ? "#2563eb" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.2s" }}>
// //                         {isSelected && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#fff" }} />}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 );
// //               })}
// //             </div>
// //           )}

// //           {/* ════ STEP 2: Resume + Extra Details ════ */}
// //           {step === 2 && (
// //             <div>
// //               {/* Selected analysis summary */}
// //               {selectedAnalysis && (
// //                 <div style={{ background: "#f0f7ff", borderRadius: 10, padding: "12px 16px", marginBottom: 18, border: "1px solid #bfdbfe", display: "flex", alignItems: "center", gap: 12 }}>
// //                   <div style={{ background: (selectedAnalysis.ats_score||0) >= 75 ? "#f0fdf4" : "#fffbeb", borderRadius: 8, padding: "6px 12px", textAlign: "center", flexShrink: 0 }}>
// //                     <div style={{ fontSize: 20, fontWeight: 900, color: (selectedAnalysis.ats_score||0) >= 75 ? "#059669" : "#d97706" }}>{selectedAnalysis.ats_score || 0}</div>
// //                     <div style={{ fontSize: 9, color: "#64748b", fontWeight: 600 }}>ATS</div>
// //                   </div>
// //                   <div>
// //                     <div style={{ fontSize: 13, fontWeight: 700, color: "#1e40af" }}>
// //                       Analysis #{analyses.findIndex(a => a.id === selectedAnalysis.id) !== -1 ? analyses.length - analyses.findIndex(a => a.id === selectedAnalysis.id) : 1} selected
// //                     </div>
// //                     <div style={{ fontSize: 11, color: "#3b82f6", marginTop: 2 }}>
// //                       {selectedAnalysis.missing_keywords?.length || 0} keywords to inject · {selectedAnalysis.match_rate || 0}% match rate
// //                     </div>
// //                   </div>
// //                 </div>
// //               )}

// //               {/* ── Resume input ── */}
// //               <div style={{ background: "#fff", border: resumeText ? "2px solid #86efac" : "1.5px solid #e2e8f0", borderRadius: 14, overflow: "hidden", marginBottom: 16, transition: "border-color 0.2s" }}>
// //                 <div style={{ padding: "14px 18px", background: resumeText ? "linear-gradient(135deg,#f0fdf4,#ecfdf5)" : "#fafaf9", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
// //                   <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //                     <div style={{ width: 34, height: 34, borderRadius: 9, background: resumeText ? "#dcfce7" : "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>
// //                       {resumeText ? "✅" : "📄"}
// //                     </div>
// //                     <div>
// //                       <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>
// //                         {resumeText ? `Resume ready (${resumeText.split(" ").length} words)` : "Your Resume"}
// //                       </div>
// //                       <div style={{ fontSize: 11, color: resumeText ? "#059669" : "#94a3b8" }}>
// //                         {resumeText ? "AI will use this as the base and improve it" : "Upload or paste — AI will preserve your real data"}
// //                       </div>
// //                     </div>
// //                   </div>
// //                   {/* Toggle */}
// //                   <div style={{ display: "flex", background: "#f1f5f9", borderRadius: 8, padding: 3, gap: 2 }}>
// //                     {[{id:"upload", label:"📎 Upload"},{id:"paste", label:"✏️ Paste"}].map(m => (
// //                       <button key={m.id} onClick={() => setUploadMode(m.id)}
// //                         style={{ padding: "5px 12px", borderRadius: 6, border: "none", fontSize: 11, fontWeight: 600, cursor: "pointer", background: uploadMode === m.id ? "#fff" : "transparent", color: uploadMode === m.id ? "#1e293b" : "#64748b", boxShadow: uploadMode === m.id ? "0 1px 3px rgba(0,0,0,0.08)" : "none" }}
// //                       >{m.label}</button>
// //                     ))}
// //                   </div>
// //                 </div>
// //                 <div style={{ padding: "14px 18px" }}>
// //                   {uploadMode === "upload" ? (
// //                     <div
// //                       onClick={() => fileRef.current.click()}
// //                       style={{ border: `2px dashed ${resumeText ? "#86efac" : "#cbd5e1"}`, borderRadius: 10, padding: "24px 16px", textAlign: "center", cursor: "pointer", background: resumeText ? "#f0fdf4" : "#f8fafc", transition: "all 0.2s" }}
// //                       onMouseEnter={e => { if (!resumeText) { e.currentTarget.style.borderColor = "#93c5fd"; e.currentTarget.style.background = "#eff6ff"; } }}
// //                       onMouseLeave={e => { if (!resumeText) { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; } }}
// //                       onDragOver={e => e.preventDefault()}
// //                       onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) handleFileUpload({ target: { files: [f] } }); }}
// //                     >
// //                       {resumeText ? (
// //                         <>
// //                           <div style={{ fontSize: 24, marginBottom: 8 }}>✅</div>
// //                           <div style={{ fontWeight: 700, color: "#059669", fontSize: 14, marginBottom: 4 }}>{resumeFileName || "Resume loaded"}</div>
// //                           <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>{resumeText.split(" ").length} words</div>
// //                           <button onClick={e => { e.stopPropagation(); setResumeText(""); setResumeFileName(""); }}
// //                             style={{ fontSize: 11, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 7, padding: "4px 12px", cursor: "pointer" }}>
// //                             ✕ Replace
// //                           </button>
// //                         </>
// //                       ) : (
// //                         <>
// //                           <div style={{ fontSize: 28, marginBottom: 8 }}>📁</div>
// //                           <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", marginBottom: 4 }}>Drop your resume here</div>
// //                           <div style={{ fontSize: 12, color: "#94a3b8" }}>or click to browse · .docx, .txt</div>
// //                         </>
// //                       )}
// //                       <input ref={fileRef} type="file" accept=".doc,.docx,.txt" style={{ display: "none" }} onChange={handleFileUpload} />
// //                     </div>
// //                   ) : (
// //                     <textarea
// //                       style={{ width: "100%", height: 160, resize: "vertical", fontSize: 13, padding: "12px", border: `1.5px solid ${resumeText ? "#86efac" : "#e2e8f0"}`, borderRadius: 10, fontFamily: "inherit", lineHeight: 1.6, outline: "none", color: "#1e293b", boxSizing: "border-box", background: resumeText ? "#f0fdf4" : "#fff" }}
// //                       placeholder="Paste your full resume text here..."
// //                       value={resumeText}
// //                       onChange={e => setResumeText(e.target.value)}
// //                     />
// //                   )}
// //                   {fileError && <div style={{ fontSize: 12, color: "#dc2626", marginTop: 6 }}>⚠️ {fileError}</div>}
// //                 </div>
// //               </div>

// //               {/* Info note */}
// //               <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "center", gap: 8 }}>
// //                 <span style={{ fontSize: 14, flexShrink: 0 }}>💡</span>
// //                 <span style={{ fontSize: 12, color: "#1e40af", lineHeight: 1.5 }}>
// //                   After selecting your template, you'll fill in additional details like skills, certifications and highlights on the resume generation page.
// //                 </span>
// //               </div>
// //             </div>
// //           )}

// //           {/* ════ STEP 3: Template ════ */}
// //           {step === 3 && (
// //             <div>
// //               {/* Summary of selections */}
// //               <div style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 16px", marginBottom: 18, border: "1px solid #e2e8f0", display: "flex", gap: 16, flexWrap: "wrap" }}>
// //                 <div style={{ fontSize: 12 }}>
// //                   <span style={{ color: "#64748b" }}>Analysis: </span>
// //                   <strong style={{ color: "#0f172a" }}>Score {selectedAnalysis?.ats_score || 0}</strong>
// //                   <span style={{ color: "#94a3b8" }}> · {selectedAnalysis?.missing_keywords?.length || 0} keywords to inject</span>
// //                 </div>
// //                 <div style={{ fontSize: 12 }}>
// //                   <span style={{ color: "#64748b" }}>Resume: </span>
// //                   <strong style={{ color: "#059669" }}>{resumeText.split(" ").length} words ✓</strong>
// //                 </div>

// //               </div>

// //               <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(145px,1fr))", gap: 12 }}>
// //                 {templates.map(t => (
// //                   <TemplateCard key={t.id} template={t} selected={selectedTemplate === t.id} onSelect={setSelectedTemplate} />
// //                 ))}
// //               </div>

// //               {/* Generate preview */}
// //               {activeTemplate && (
// //                 <div style={{ marginTop: 14, padding: "12px 16px", background: `${activeTemplate.accent}10`, borderRadius: 10, border: `1px solid ${activeTemplate.accent}25`, display: "flex", alignItems: "center", gap: 10 }}>
// //                   <div style={{ width: 10, height: 10, borderRadius: "50%", background: activeTemplate.accent, flexShrink: 0 }} />
// //                   <span style={{ fontSize: 13, color: activeTemplate.accent, fontWeight: 600 }}>
// //                     {activeTemplate.name} · {activeTemplate.description}
// //                   </span>
// //                 </div>
// //               )}
// //             </div>
// //           )}
// //         </div>

// //         {/* ── Footer ── */}
// //         <div style={{ padding: "14px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff" }}>
// //           <button
// //             onClick={() => step <= (analyses.length > 1 ? 1 : 2) ? onClose() : setStep(s => s - 1)}
// //             style={{ padding: "10px 18px", background: "transparent", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer" }}
// //           >
// //             {step <= (analyses.length > 1 ? 1 : 2) ? "Cancel" : "← Back"}
// //           </button>

// //           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
// //             {/* Step counter */}
// //             <span style={{ fontSize: 12, color: "#94a3b8" }}>Step {currentStepIndex + 1} of {totalSteps}</span>

// //             {step < (analyses.length > 1 ? 3 : 3) ? (
// //               <button
// //                 onClick={() => {
// //                   if (step === 2 && !resumeText.trim()) { setFileError("Please provide your resume text before continuing."); return; }
// //                   setStep(s => s + 1);
// //                 }}
// //                 disabled={step === 1 && !selectedAnalysisId}
// //                 style={{ padding: "10px 20px", background: (step === 1 && !selectedAnalysisId) ? "#e2e8f0" : "linear-gradient(135deg,#2563eb,#1d4ed8)", color: (step === 1 && !selectedAnalysisId) ? "#94a3b8" : "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: (step === 1 && !selectedAnalysisId) ? "not-allowed" : "pointer" }}
// //               >
// //                 Next →
// //               </button>
// //             ) : (
// //               <button
// //                 onClick={handleGenerate}
// //                 disabled={!resumeText.trim()}
// //                 style={{ padding: "10px 22px", background: resumeText.trim() ? `linear-gradient(135deg,${activeTemplate?.accent || "#059669"},${activeTemplate?.headerBg || "#047857"})` : "#e2e8f0", color: resumeText.trim() ? "#fff" : "#94a3b8", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: resumeText.trim() ? "pointer" : "not-allowed", boxShadow: resumeText.trim() ? `0 4px 14px ${activeTemplate?.accent || "#059669"}40` : "none", display: "flex", alignItems: "center", gap: 8 }}
// //                 onMouseEnter={e => { if (resumeText.trim()) e.currentTarget.style.transform = "translateY(-1px)"; }}
// //                 onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
// //               >
// //                 ✨ Generate My Resume
// //               </button>
// //             )}
// //           </div>
// //         </div>
// //       </div>
// //       <style>{`@keyframes fadeIn { from { opacity:0; transform:scale(0.97); } to { opacity:1; transform:scale(1); } }`}</style>
// //     </div>
// //   );
// // }

// // src/components/AnalysisSelectModal.jsx
// // 3-step modal before resume generation:
// // Step 1 — Select analysis (skip if only 1)
// // Step 2 — Confirm resume text (extra details like skills filled on ResumeGeneratorPage)
// // Step 3 — Choose template
// // → navigates to /generate-resume with all data

// import { useState, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import servicesConfig from "../utils/servicesConfig";

// import { extractFileText } from "../utils/extractFileText";

// import TemplateMini from "../components/TemplateMini";

// // ── Template card using shared TemplateMini ──
// function TemplateCard({ template, selected, onSelect }) {
//   const { accent } = template;
//   return (
//     <div
//       onClick={() => onSelect(template.id)}
//       style={{
//         borderRadius: 12, border: selected ? `2px solid ${accent}` : "1.5px solid #e2e8f0",
//         background: "#fff", cursor: "pointer", transition: "all 0.2s",
//         overflow: "hidden", position: "relative",
//         boxShadow: selected ? `0 6px 20px ${accent}28` : "0 1px 4px rgba(0,0,0,0.04)",
//         transform: selected ? "translateY(-2px) scale(1.01)" : "none",
//       }}
//       onMouseEnter={e => { if (!selected) { e.currentTarget.style.borderColor = accent; e.currentTarget.style.transform = "translateY(-1px)"; } }}
//       onMouseLeave={e => { if (!selected) { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; } }}
//     >
//       {selected && (
//         <div style={{ position: "absolute", top: 6, right: 6, background: accent, color: "#fff", fontSize: 9, fontWeight: 700, padding: "1px 7px", borderRadius: 20, zIndex: 3 }}>✓ Selected</div>
//       )}
//       {/* Accurate mini preview */}
//       <div style={{ background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "8px 8px 4px" }}>
//         <TemplateMini t={template} scale={0.25} width={600} />
//       </div>
//       <div style={{ padding: "7px 10px 9px", borderTop: "1px solid #f1f5f9" }}>
//         <div style={{ fontWeight: 700, fontSize: 12, color: "#0f172a", marginBottom: 1 }}>{template.name}</div>
//         <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, lineHeight: 1.4 }}>{template.description}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
//           {template.tags.map(t => <span key={t} style={{ fontSize: 9, padding: "1px 5px", borderRadius: 20, background: `${accent}12`, color: accent, fontWeight: 600 }}>{t}</span>)}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function AnalysisSelectModal({ analyses, transactionId, planId, onClose, userData }) {
//   const navigate  = useNavigate();
//   const fileRef   = useRef();

//   // ── Step state ──
//   const totalSteps = analyses.length > 1 ? 3 : 2; // skip step 1 if only 1 analysis
//   const [step, setStep] = useState(analyses.length > 1 ? 1 : 2);

//   // ── Step 1: Analysis selection ──
//   const [selectedAnalysisId, setSelectedAnalysisId] = useState(analyses[0]?.id || null);

//   // ── Step 2: Resume + extra details ──
//   const selectedAnalysis = analyses.find(a => a.id === selectedAnalysisId) || analyses[0];
//   const [resumeText, setResumeText]       = useState(selectedAnalysis?.resumeText || "");
//   const [resumeFileName, setResumeFileName] = useState("");
//   const [uploadMode, setUploadMode]       = useState(resumeText ? "paste" : "upload");
//   const [fileError, setFileError]         = useState("");

//   // ── Step 3: Template selection ──
//   // Templates strictly from plan's resumeTemplateIds — never shows all
//   // normalizePlanId handles old transactions saved with service code as planId
//   const LEGACY_PLAN_MAP = { "ATS_ANALYSIS":"ats_basic","ATS_RESUME_SAMPLE":"ats_basic","ATS_RESUME_IMPROVED":"ats_basic","DOCUMENT_SUMMARY":"doc_pro","DOCUMENT_CHAT":"doc_pro" };
//   const normalPlanId = LEGACY_PLAN_MAP[planId] || planId || "ats_basic";
//   const planConfig = servicesConfig.plans.find(p => p.id === normalPlanId);
//   const templates = (() => {
//     if (planConfig?.resumeTemplateIds?.length > 0) {
//       return servicesConfig.resumeTemplates.filter(t =>
//         t.active &&
//         !t.comingSoon &&
//         planConfig.resumeTemplateIds.includes(t.id)
//       );
//     }
//     // Hard fallback to ats_basic only
//     const basicPlan = servicesConfig.plans.find(p => p.id === "ats_basic");
//     return servicesConfig.resumeTemplates.filter(t =>
//       t.active && !t.comingSoon && (basicPlan?.resumeTemplateIds || []).includes(t.id)
//     );
//   })();
//   const [selectedTemplate, setSelectedTemplate] = useState("classic");

//   const activeTemplate = templates.find(t => t.id === selectedTemplate) || templates[0];

//   async function handleFileUpload(e) {
//     const file = e.target.files[0];
//     if (!file) return;
//     setFileError("");
//     try {
//       const text = await extractFileText(file);
//       if (!text || text.length < 50) { setFileError("Could not extract text. Try pasting instead."); return; }
//       setResumeText(text);
//       setResumeFileName(file.name);
//     } catch (err) {
//       setFileError(err.message || "Could not read file.");
//     }
//   }

//   function fmtDate(ts) {
//     if (!ts) return "";
//     const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
//     return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
//   }

//   function handleGenerate() {
//     if (!resumeText.trim()) return;
//     onClose();
//     navigate("/generate-resume", {
//       state: {
//         resumeText,
//         jobDescription:  selectedAnalysis?.jobDescription || "",
//         analysisResult:  selectedAnalysis,
//         templateId:      selectedTemplate,
//         transactionId,
//         fromDashboard:   true,

//       },
//     });
//   }

//   // Step labels
//   const stepLabels = analyses.length > 1
//     ? ["Select Analysis", "Your Resume", "Choose Template"]
//     : ["Your Resume", "Choose Template"];

//   const currentStepIndex = analyses.length > 1 ? step - 1 : step - 2;

//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(15,23,42,0.78)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
//       <div style={{ background: "#fff", borderRadius: 20, width: "100%", maxWidth: 700, maxHeight: "92vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 24px 60px rgba(0,0,0,0.3)", animation: "fadeIn 0.25s ease" }}>

//         {/* ── Header ── */}
//         <div style={{ padding: "20px 24px 0", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
//           <div>
//             <h2 style={{ fontSize: 18, fontWeight: 800, color: "#0f172a", marginBottom: 4, letterSpacing: "-0.01em" }}>
//               {step === 1 ? "📊 Select Best Analysis" : step === 2 ? "📄 Your Resume & Details" : "🎨 Choose Template"}
//             </h2>
//             <p style={{ fontSize: 13, color: "#64748b", margin: 0 }}>
//               {step === 1 ? "Pick the analysis you're most satisfied with"
//                 : step === 2 ? "Upload or confirm your resume — the AI will use this as the base for improvement"
//                 : "Select the layout style for your improved resume"}
//             </p>
//           </div>
//           <button onClick={onClose} style={{ width: 32, height: 32, borderRadius: "50%", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontSize: 18, display: "flex", alignItems: "center", justifyContent: "center", color: "#64748b", flexShrink: 0, marginLeft: 12 }}>×</button>
//         </div>

//         {/* ── Step indicator ── */}
//         <div style={{ padding: "14px 24px 0", display: "flex", alignItems: "center", gap: 6 }}>
//           {stepLabels.map((label, i) => (
//             <div key={i} style={{ display: "flex", alignItems: "center", gap: 6 }}>
//               <div style={{ width: 26, height: 26, borderRadius: "50%", background: currentStepIndex > i ? "linear-gradient(135deg,#059669,#047857)" : currentStepIndex === i ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#f1f5f9", color: currentStepIndex >= i ? "#fff" : "#94a3b8", fontSize: 11, fontWeight: 800, display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.3s", flexShrink: 0 }}>
//                 {currentStepIndex > i ? "✓" : i + 1}
//               </div>
//               <span style={{ fontSize: 12, fontWeight: 600, color: currentStepIndex === i ? "#0f172a" : "#94a3b8", whiteSpace: "nowrap" }}>{label}</span>
//               {i < stepLabels.length - 1 && <div style={{ width: 24, height: 1.5, background: currentStepIndex > i ? "#059669" : "#e2e8f0", margin: "0 4px", transition: "all 0.3s" }} />}
//             </div>
//           ))}
//         </div>

//         <div style={{ height: 1, background: "#f1f5f9", margin: "14px 0 0" }} />

//         {/* ── Scrollable body ── */}
//         <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px" }}>

//           {/* ════ STEP 1: Select Analysis ════ */}
//           {step === 1 && (
//             <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
//               {analyses.map((a, idx) => {
//                 const score      = a.ats_score || 0;
//                 const scoreColor = score >= 75 ? "#059669" : score >= 50 ? "#d97706" : "#dc2626";
//                 const scoreBg    = score >= 75 ? "#f0fdf4" : score >= 50 ? "#fffbeb" : "#fef2f2";
//                 const isSelected = selectedAnalysisId === a.id;
//                 return (
//                   <div key={a.id} onClick={() => setSelectedAnalysisId(a.id)}
//                     style={{ borderRadius: 14, border: isSelected ? "2px solid #2563eb" : "1.5px solid #e2e8f0", background: isSelected ? "#f0f7ff" : "#fff", cursor: "pointer", padding: "16px 18px", transition: "all 0.2s", boxShadow: isSelected ? "0 4px 16px rgba(37,99,235,0.12)" : "none" }}
//                     onMouseEnter={e => { if (!isSelected) e.currentTarget.style.borderColor = "#93c5fd"; }}
//                     onMouseLeave={e => { if (!isSelected) e.currentTarget.style.borderColor = "#e2e8f0"; }}
//                   >
//                     <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
//                       <div style={{ background: scoreBg, borderRadius: 10, padding: "8px 14px", textAlign: "center", minWidth: 68, flexShrink: 0 }}>
//                         <div style={{ fontSize: 9, fontWeight: 700, color: scoreColor, textTransform: "uppercase", letterSpacing: "0.06em" }}>Score</div>
//                         <div style={{ fontSize: 24, fontWeight: 900, color: scoreColor, lineHeight: 1 }}>{score}</div>
//                       </div>
//                       <div style={{ flex: 1, minWidth: 0 }}>
//                         <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4, flexWrap: "wrap" }}>
//                           <span style={{ fontWeight: 700, fontSize: 14, color: "#0f172a" }}>Analysis #{analyses.length - idx}</span>
//                           {isSelected && <span style={{ fontSize: 10, background: "#2563eb", color: "#fff", padding: "1px 8px", borderRadius: 20, fontWeight: 700 }}>✓ Selected</span>}
//                           {idx === 0 && <span style={{ fontSize: 10, background: "#f0fdf4", color: "#059669", padding: "1px 8px", borderRadius: 20, fontWeight: 700, border: "1px solid #bbf7d0" }}>Most Recent</span>}
//                           <span style={{ fontSize: 11, color: "#94a3b8" }}>{fmtDate(a.createdAt)}</span>
//                         </div>
//                         <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
//                           <span style={{ fontSize: 12, color: "#475569" }}>Match: <strong style={{ color: "#0f172a" }}>{a.match_rate || 0}%</strong></span>
//                           <span style={{ fontSize: 12, color: "#475569" }}>Missing: <strong style={{ color: "#dc2626" }}>{a.missing_count || 0}</strong> keywords</span>
//                         </div>
//                         {a.missing_keywords?.length > 0 && (
//                           <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 6 }}>
//                             {a.missing_keywords.slice(0, 5).map(k => <span key={k} style={{ fontSize: 10, background: "#fef2f2", color: "#dc2626", padding: "1px 7px", borderRadius: 20, fontWeight: 600 }}>{k}</span>)}
//                             {a.missing_keywords.length > 5 && <span style={{ fontSize: 10, color: "#94a3b8" }}>+{a.missing_keywords.length - 5} more</span>}
//                           </div>
//                         )}
//                       </div>
//                       <div style={{ width: 22, height: 22, borderRadius: "50%", border: `2px solid ${isSelected ? "#2563eb" : "#cbd5e1"}`, background: isSelected ? "#2563eb" : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, transition: "all 0.2s" }}>
//                         {isSelected && <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#fff" }} />}
//                       </div>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           )}

//           {/* ════ STEP 2: Resume + Extra Details ════ */}
//           {step === 2 && (
//             <div>
//               {/* Selected analysis summary */}
//               {selectedAnalysis && (
//                 <div style={{ background: "#f0f7ff", borderRadius: 10, padding: "12px 16px", marginBottom: 18, border: "1px solid #bfdbfe", display: "flex", alignItems: "center", gap: 12 }}>
//                   <div style={{ background: (selectedAnalysis.ats_score||0) >= 75 ? "#f0fdf4" : "#fffbeb", borderRadius: 8, padding: "6px 12px", textAlign: "center", flexShrink: 0 }}>
//                     <div style={{ fontSize: 20, fontWeight: 900, color: (selectedAnalysis.ats_score||0) >= 75 ? "#059669" : "#d97706" }}>{selectedAnalysis.ats_score || 0}</div>
//                     <div style={{ fontSize: 9, color: "#64748b", fontWeight: 600 }}>ATS</div>
//                   </div>
//                   <div>
//                     <div style={{ fontSize: 13, fontWeight: 700, color: "#1e40af" }}>
//                       Analysis #{analyses.findIndex(a => a.id === selectedAnalysis.id) !== -1 ? analyses.length - analyses.findIndex(a => a.id === selectedAnalysis.id) : 1} selected
//                     </div>
//                     <div style={{ fontSize: 11, color: "#3b82f6", marginTop: 2 }}>
//                       {selectedAnalysis.missing_keywords?.length || 0} keywords to inject · {selectedAnalysis.match_rate || 0}% match rate
//                     </div>
//                   </div>
//                 </div>
//               )}

//               {/* ── Resume input ── */}
//               <div style={{ background: "#fff", border: resumeText ? "2px solid #86efac" : "1.5px solid #e2e8f0", borderRadius: 14, overflow: "hidden", marginBottom: 16, transition: "border-color 0.2s" }}>
//                 <div style={{ padding: "14px 18px", background: resumeText ? "linear-gradient(135deg,#f0fdf4,#ecfdf5)" : "#fafaf9", borderBottom: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
//                   <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//                     <div style={{ width: 34, height: 34, borderRadius: 9, background: resumeText ? "#dcfce7" : "#eff6ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>
//                       {resumeText ? "✅" : "📄"}
//                     </div>
//                     <div>
//                       <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a" }}>
//                         {resumeText ? `Resume ready (${resumeText.split(" ").length} words)` : "Your Resume"}
//                       </div>
//                       <div style={{ fontSize: 11, color: resumeText ? "#059669" : "#94a3b8" }}>
//                         {resumeText ? "AI will use this as the base and improve it" : "Upload or paste — AI will preserve your real data"}
//                       </div>
//                     </div>
//                   </div>
//                   {/* Toggle */}
//                   <div style={{ display: "flex", background: "#f1f5f9", borderRadius: 8, padding: 3, gap: 2 }}>
//                     {[{id:"upload", label:"📎 Upload"},{id:"paste", label:"✏️ Paste"}].map(m => (
//                       <button key={m.id} onClick={() => setUploadMode(m.id)}
//                         style={{ padding: "5px 12px", borderRadius: 6, border: "none", fontSize: 11, fontWeight: 600, cursor: "pointer", background: uploadMode === m.id ? "#fff" : "transparent", color: uploadMode === m.id ? "#1e293b" : "#64748b", boxShadow: uploadMode === m.id ? "0 1px 3px rgba(0,0,0,0.08)" : "none" }}
//                       >{m.label}</button>
//                     ))}
//                   </div>
//                 </div>
//                 <div style={{ padding: "14px 18px" }}>
//                   {uploadMode === "upload" ? (
//                     <div
//                       onClick={() => fileRef.current.click()}
//                       style={{ border: `2px dashed ${resumeText ? "#86efac" : "#cbd5e1"}`, borderRadius: 10, padding: "24px 16px", textAlign: "center", cursor: "pointer", background: resumeText ? "#f0fdf4" : "#f8fafc", transition: "all 0.2s" }}
//                       onMouseEnter={e => { if (!resumeText) { e.currentTarget.style.borderColor = "#93c5fd"; e.currentTarget.style.background = "#eff6ff"; } }}
//                       onMouseLeave={e => { if (!resumeText) { e.currentTarget.style.borderColor = "#cbd5e1"; e.currentTarget.style.background = "#f8fafc"; } }}
//                       onDragOver={e => e.preventDefault()}
//                       onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) handleFileUpload({ target: { files: [f] } }); }}
//                     >
//                       {resumeText ? (
//                         <>
//                           <div style={{ fontSize: 24, marginBottom: 8 }}>✅</div>
//                           <div style={{ fontWeight: 700, color: "#059669", fontSize: 14, marginBottom: 4 }}>{resumeFileName || "Resume loaded"}</div>
//                           <div style={{ fontSize: 12, color: "#64748b", marginBottom: 8 }}>{resumeText.split(" ").length} words</div>
//                           <button onClick={e => { e.stopPropagation(); setResumeText(""); setResumeFileName(""); }}
//                             style={{ fontSize: 11, color: "#64748b", background: "#f1f5f9", border: "none", borderRadius: 7, padding: "4px 12px", cursor: "pointer" }}>
//                             ✕ Replace
//                           </button>
//                         </>
//                       ) : (
//                         <>
//                           <div style={{ fontSize: 28, marginBottom: 8 }}>📁</div>
//                           <div style={{ fontWeight: 700, fontSize: 13, color: "#0f172a", marginBottom: 4 }}>Drop your resume here</div>
//                           <div style={{ fontSize: 12, color: "#94a3b8" }}>or click to browse · .docx, .txt</div>
//                         </>
//                       )}
//                       <input ref={fileRef} type="file" accept=".doc,.docx,.txt" style={{ display: "none" }} onChange={handleFileUpload} />
//                     </div>
//                   ) : (
//                     <textarea
//                       style={{ width: "100%", height: 160, resize: "vertical", fontSize: 13, padding: "12px", border: `1.5px solid ${resumeText ? "#86efac" : "#e2e8f0"}`, borderRadius: 10, fontFamily: "inherit", lineHeight: 1.6, outline: "none", color: "#1e293b", boxSizing: "border-box", background: resumeText ? "#f0fdf4" : "#fff" }}
//                       placeholder="Paste your full resume text here..."
//                       value={resumeText}
//                       onChange={e => setResumeText(e.target.value)}
//                     />
//                   )}
//                   {fileError && <div style={{ fontSize: 12, color: "#dc2626", marginTop: 6 }}>⚠️ {fileError}</div>}
//                 </div>
//               </div>

//               {/* Info note */}
//               <div style={{ background: "#eff6ff", border: "1px solid #bfdbfe", borderRadius: 10, padding: "10px 14px", display: "flex", alignItems: "center", gap: 8 }}>
//                 <span style={{ fontSize: 14, flexShrink: 0 }}>💡</span>
//                 <span style={{ fontSize: 12, color: "#1e40af", lineHeight: 1.5 }}>
//                   After selecting your template, you'll fill in additional details like skills, certifications and highlights on the resume generation page.
//                 </span>
//               </div>
//             </div>
//           )}

//           {/* ════ STEP 3: Template ════ */}
//           {step === 3 && (
//             <div>
//               {/* Summary of selections */}
//               <div style={{ background: "#f8fafc", borderRadius: 10, padding: "12px 16px", marginBottom: 18, border: "1px solid #e2e8f0", display: "flex", gap: 16, flexWrap: "wrap" }}>
//                 <div style={{ fontSize: 12 }}>
//                   <span style={{ color: "#64748b" }}>Analysis: </span>
//                   <strong style={{ color: "#0f172a" }}>Score {selectedAnalysis?.ats_score || 0}</strong>
//                   <span style={{ color: "#94a3b8" }}> · {selectedAnalysis?.missing_keywords?.length || 0} keywords to inject</span>
//                 </div>
//                 <div style={{ fontSize: 12 }}>
//                   <span style={{ color: "#64748b" }}>Resume: </span>
//                   <strong style={{ color: "#059669" }}>{resumeText.split(" ").length} words ✓</strong>
//                 </div>

//               </div>

//               <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(145px,1fr))", gap: 12 }}>
//                 {templates.map(t => (
//                   <TemplateCard key={t.id} template={t} selected={selectedTemplate === t.id} onSelect={setSelectedTemplate} />
//                 ))}
//               </div>

//               {/* Generate preview */}
//               {activeTemplate && (
//                 <div style={{ marginTop: 14, padding: "12px 16px", background: `${activeTemplate.accent}10`, borderRadius: 10, border: `1px solid ${activeTemplate.accent}25`, display: "flex", alignItems: "center", gap: 10 }}>
//                   <div style={{ width: 10, height: 10, borderRadius: "50%", background: activeTemplate.accent, flexShrink: 0 }} />
//                   <span style={{ fontSize: 13, color: activeTemplate.accent, fontWeight: 600 }}>
//                     {activeTemplate.name} · {activeTemplate.description}
//                   </span>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* ── Footer ── */}
//         <div style={{ padding: "14px 24px", borderTop: "1px solid #f1f5f9", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#fff" }}>
//           <button
//             onClick={() => step <= (analyses.length > 1 ? 1 : 2) ? onClose() : setStep(s => s - 1)}
//             style={{ padding: "10px 18px", background: "transparent", color: "#64748b", border: "1px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer" }}
//           >
//             {step <= (analyses.length > 1 ? 1 : 2) ? "Cancel" : "← Back"}
//           </button>

//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             {/* Step counter */}
//             <span style={{ fontSize: 12, color: "#94a3b8" }}>Step {currentStepIndex + 1} of {totalSteps}</span>

//             {step < (analyses.length > 1 ? 3 : 3) ? (
//               <button
//                 onClick={() => {
//                   if (step === 2 && !resumeText.trim()) { setFileError("Please provide your resume text before continuing."); return; }
//                   setStep(s => s + 1);
//                 }}
//                 disabled={step === 1 && !selectedAnalysisId}
//                 style={{ padding: "10px 20px", background: (step === 1 && !selectedAnalysisId) ? "#e2e8f0" : "linear-gradient(135deg,#2563eb,#1d4ed8)", color: (step === 1 && !selectedAnalysisId) ? "#94a3b8" : "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: (step === 1 && !selectedAnalysisId) ? "not-allowed" : "pointer" }}
//               >
//                 Next →
//               </button>
//             ) : (
//               <button
//                 onClick={handleGenerate}
//                 disabled={!resumeText.trim()}
//                 style={{ padding: "10px 22px", background: resumeText.trim() ? `linear-gradient(135deg,${activeTemplate?.accent || "#059669"},${activeTemplate?.headerBg || "#047857"})` : "#e2e8f0", color: resumeText.trim() ? "#fff" : "#94a3b8", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: resumeText.trim() ? "pointer" : "not-allowed", boxShadow: resumeText.trim() ? `0 4px 14px ${activeTemplate?.accent || "#059669"}40` : "none", display: "flex", alignItems: "center", gap: 8 }}
//                 onMouseEnter={e => { if (resumeText.trim()) e.currentTarget.style.transform = "translateY(-1px)"; }}
//                 onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
//               >
//                 ✨ Generate My Resume
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//       <style>{`@keyframes fadeIn { from { opacity:0; transform:scale(0.97); } to { opacity:1; transform:scale(1); } }`}</style>
//     </div>
//   );
// }

//---new code

import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import servicesConfig from "../utils/servicesConfig";
import { extractFileText } from "../utils/extractFileText";
import TemplateMini from "../components/TemplateMini";

function TemplateCard({ template, selected, onSelect }) {
  const { accent } = template;
  return (
    <div
      onClick={() => onSelect(template.id)}
      style={{
        borderRadius: 12, border: selected ? `2px solid ${accent}` : "1.5px solid #e2e8f0",
        background: "#fff", cursor: "pointer", transition: "all 0.2s",
        overflow: "hidden", position: "relative",
        boxShadow: selected ? `0 6px 20px ${accent}28` : "0 1px 4px rgba(0,0,0,0.04)",
        transform: selected ? "translateY(-2px) scale(1.01)" : "none",
      }}
      onMouseEnter={e => { if (!selected) { e.currentTarget.style.borderColor = accent; e.currentTarget.style.transform = "translateY(-1px)"; } }}
      onMouseLeave={e => { if (!selected) { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; } }}
    >
      {selected && (
        <div style={{ position: "absolute", top: 6, right: 6, background: accent, color: "#fff", fontSize: 9, fontWeight: 700, padding: "1px 7px", borderRadius: 20, zIndex: 3 }}>✓ Selected</div>
      )}
      <div style={{ background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 8px 6px" }}>
        <TemplateMini t={template} scale={0.32} width={560} />
      </div>
      <div style={{ padding: "7px 10px 9px", borderTop: "1px solid #f1f5f9" }}>
        <div style={{ fontWeight: 700, fontSize: 12, color: "#0f172a", marginBottom: 1 }}>{template.name}</div>
        <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, lineHeight: 1.4 }}>{template.description}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
          {template.tags.map(t => <span key={t} style={{ fontSize: 9, padding: "1px 5px", borderRadius: 20, background: `${accent}12`, color: accent, fontWeight: 600 }}>{t}</span>)}
        </div>
      </div>
    </div>
  );
}

export default function AnalysisSelectModal({ analyses, transactionId, planId, onClose, userData }) {
  const navigate = useNavigate();
  const fileRef  = useRef();

  const totalSteps       = analyses.length > 1 ? 3 : 2;
  const [step, setStep]  = useState(analyses.length > 1 ? 1 : 2);

  // Step 1
  const [selectedAnalysisId, setSelectedAnalysisId] = useState(analyses[0]?.id || null);
  const selectedAnalysis = analyses.find(a => a.id === selectedAnalysisId) || analyses[0];

  // Step 2
  const [resumeText, setResumeText]         = useState(selectedAnalysis?.resumeText || "");
  const [resumeFileName, setResumeFileName] = useState("");
  const [uploadMode, setUploadMode]         = useState(resumeText ? "paste" : "upload");
  const [fileError, setFileError]           = useState("");

  // Step 3 — templates from plan
  const LEGACY_PLAN_MAP = {
    "ATS_ANALYSIS":"ats_basic","ATS_RESUME_SAMPLE":"ats_basic",
    "ATS_RESUME_IMPROVED":"ats_basic","DOCUMENT_SUMMARY":"doc_pro","DOCUMENT_CHAT":"doc_pro",
  };
  const normalPlanId = LEGACY_PLAN_MAP[planId] || planId || "ats_basic";
  const planConfig   = servicesConfig.plans.find(p => p.id === normalPlanId);

  const templates = (() => {
    const ids = planConfig?.resumeTemplateIds;
    if (ids?.length > 0) {
      return servicesConfig.resumeTemplates.filter(t => t.active && !t.comingSoon && ids.includes(t.id));
    }
    const basicIds = servicesConfig.plans.find(p => p.id === "ats_basic")?.resumeTemplateIds || [];
    return servicesConfig.resumeTemplates.filter(t => t.active && !t.comingSoon && basicIds.includes(t.id));
  })();

  // ── FIX: initialize to first available template, not hardcoded "classic" ──
  const [selectedTemplate, setSelectedTemplate] = useState(() => templates[0]?.id || "classic");

  // Sync if templates change (e.g. plan changes after mount)
  useEffect(() => {
    if (templates.length > 0 && !templates.find(t => t.id === selectedTemplate)) {
      setSelectedTemplate(templates[0].id);
    }
  }, [templates, selectedTemplate]);

  const activeTemplate = templates.find(t => t.id === selectedTemplate) || templates[0];

  async function handleFileUpload(e) {
    const file = e.target.files[0];
    if (!file) return;
    setFileError("");
    try {
      const text = await extractFileText(file);
      if (!text || text.length < 50) { setFileError("Could not extract text. Try pasting instead."); return; }
      setResumeText(text);
      setResumeFileName(file.name);
    } catch (err) {
      setFileError(err.message || "Could not read file.");
    }
  }

  function fmtDate(ts) {
    if (!ts) return "";
    const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
    return d.toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  }

  function handleGenerate() {
    if (!resumeText.trim()) return;
    // ── FIX: use activeTemplate.id to guarantee a valid template is always passed ──
    const templateToUse = activeTemplate?.id || templates[0]?.id || "classic";
    onClose();
    navigate("/generate-resume", {
      state: {
        resumeText,
        jobDescription: selectedAnalysis?.jobDescription || "",
        analysisResult: selectedAnalysis,
        templateId:     templateToUse,
        transactionId,
        fromDashboard:  true,
      },
    });
  }

  const stepLabels       = analyses.length > 1
    ? ["Select Analysis", "Your Resume", "Choose Template"]
    : ["Your Resume", "Choose Template"];
  const currentStepIndex = analyses.length > 1 ? step - 1 : step - 2;

  return (
    <div style={{ position:"fixed", inset:0, zIndex:2000, background:"rgba(15,23,42,0.78)", backdropFilter:"blur(6px)", display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
      <div style={{ background:"#fff", borderRadius:20, width:"100%", maxWidth:700, maxHeight:"92vh", overflow:"hidden", display:"flex", flexDirection:"column", boxShadow:"0 24px 60px rgba(0,0,0,0.3)", animation:"fadeIn 0.25s ease" }}>

        {/* Header */}
        <div style={{ padding:"20px 24px 0", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <h2 style={{ fontSize:18, fontWeight:800, color:"#0f172a", marginBottom:4, letterSpacing:"-0.01em" }}>
              {step===1 ? "📊 Select Best Analysis" : step===2 ? "📄 Your Resume & Details" : "🎨 Choose Template"}
            </h2>
            <p style={{ fontSize:13, color:"#64748b", margin:0 }}>
              {step===1 ? "Pick the analysis you're most satisfied with"
                : step===2 ? "Upload or confirm your resume — the AI will use this as the base for improvement"
                : "Select the layout style for your improved resume"}
            </p>
          </div>
          <button onClick={onClose} style={{ width:32, height:32, borderRadius:"50%", border:"1px solid #e2e8f0", background:"#fff", cursor:"pointer", fontSize:18, display:"flex", alignItems:"center", justifyContent:"center", color:"#64748b", flexShrink:0, marginLeft:12 }}>×</button>
        </div>

        {/* Step indicator */}
        <div style={{ padding:"14px 24px 0", display:"flex", alignItems:"center", gap:6 }}>
          {stepLabels.map((label, i) => (
            <div key={i} style={{ display:"flex", alignItems:"center", gap:6 }}>
              <div style={{ width:26, height:26, borderRadius:"50%", background: currentStepIndex>i ? "linear-gradient(135deg,#059669,#047857)" : currentStepIndex===i ? "linear-gradient(135deg,#2563eb,#1d4ed8)" : "#f1f5f9", color: currentStepIndex>=i ? "#fff" : "#94a3b8", fontSize:11, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", transition:"all 0.3s", flexShrink:0 }}>
                {currentStepIndex>i ? "✓" : i+1}
              </div>
              <span style={{ fontSize:12, fontWeight:600, color: currentStepIndex===i ? "#0f172a" : "#94a3b8", whiteSpace:"nowrap" }}>{label}</span>
              {i < stepLabels.length-1 && <div style={{ width:24, height:1.5, background: currentStepIndex>i ? "#059669" : "#e2e8f0", margin:"0 4px", transition:"all 0.3s" }} />}
            </div>
          ))}
        </div>

        <div style={{ height:1, background:"#f1f5f9", margin:"14px 0 0" }} />

        {/* Body */}
        <div style={{ flex:1, overflowY:"auto", padding:"20px 24px" }}>

          {/* STEP 1: Select Analysis */}
          {step===1 && (
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {analyses.map((a, idx) => {
                const score      = a.ats_score || 0;
                const scoreColor = score>=75 ? "#059669" : score>=50 ? "#d97706" : "#dc2626";
                const scoreBg    = score>=75 ? "#f0fdf4" : score>=50 ? "#fffbeb" : "#fef2f2";
                const isSel      = selectedAnalysisId === a.id;
                return (
                  <div key={a.id} onClick={() => setSelectedAnalysisId(a.id)}
                    style={{ borderRadius:14, border: isSel ? "2px solid #2563eb" : "1.5px solid #e2e8f0", background: isSel ? "#f0f7ff" : "#fff", cursor:"pointer", padding:"16px 18px", transition:"all 0.2s", boxShadow: isSel ? "0 4px 16px rgba(37,99,235,0.12)" : "none" }}
                    onMouseEnter={e => { if (!isSel) e.currentTarget.style.borderColor="#93c5fd"; }}
                    onMouseLeave={e => { if (!isSel) e.currentTarget.style.borderColor="#e2e8f0"; }}
                  >
                    <div style={{ display:"flex", alignItems:"center", gap:14, flexWrap:"wrap" }}>
                      <div style={{ background:scoreBg, borderRadius:10, padding:"8px 14px", textAlign:"center", minWidth:68, flexShrink:0 }}>
                        <div style={{ fontSize:9, fontWeight:700, color:scoreColor, textTransform:"uppercase", letterSpacing:"0.06em" }}>Score</div>
                        <div style={{ fontSize:24, fontWeight:900, color:scoreColor, lineHeight:1 }}>{score}</div>
                      </div>
                      <div style={{ flex:1, minWidth:0 }}>
                        <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                          <span style={{ fontWeight:700, fontSize:14, color:"#0f172a" }}>Analysis #{analyses.length-idx}</span>
                          {isSel && <span style={{ fontSize:10, background:"#2563eb", color:"#fff", padding:"1px 8px", borderRadius:20, fontWeight:700 }}>✓ Selected</span>}
                          {idx===0 && <span style={{ fontSize:10, background:"#f0fdf4", color:"#059669", padding:"1px 8px", borderRadius:20, fontWeight:700, border:"1px solid #bbf7d0" }}>Most Recent</span>}
                          <span style={{ fontSize:11, color:"#94a3b8" }}>{fmtDate(a.createdAt)}</span>
                        </div>
                        <div style={{ display:"flex", gap:12, flexWrap:"wrap" }}>
                          <span style={{ fontSize:12, color:"#475569" }}>Match: <strong style={{ color:"#0f172a" }}>{a.match_rate||0}%</strong></span>
                          <span style={{ fontSize:12, color:"#475569" }}>Missing: <strong style={{ color:"#dc2626" }}>{a.missing_count||0}</strong> keywords</span>
                        </div>
                        {a.missing_keywords?.length>0 && (
                          <div style={{ display:"flex", flexWrap:"wrap", gap:4, marginTop:6 }}>
                            {a.missing_keywords.slice(0,5).map(k=><span key={k} style={{ fontSize:10, background:"#fef2f2", color:"#dc2626", padding:"1px 7px", borderRadius:20, fontWeight:600 }}>{k}</span>)}
                            {a.missing_keywords.length>5 && <span style={{ fontSize:10, color:"#94a3b8" }}>+{a.missing_keywords.length-5} more</span>}
                          </div>
                        )}
                      </div>
                      <div style={{ width:22, height:22, borderRadius:"50%", border:`2px solid ${isSel?"#2563eb":"#cbd5e1"}`, background: isSel?"#2563eb":"#fff", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, transition:"all 0.2s" }}>
                        {isSel && <div style={{ width:8, height:8, borderRadius:"50%", background:"#fff" }} />}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* STEP 2: Resume */}
          {step===2 && (
            <div>
              {selectedAnalysis && (
                <div style={{ background:"#f0f7ff", borderRadius:10, padding:"12px 16px", marginBottom:18, border:"1px solid #bfdbfe", display:"flex", alignItems:"center", gap:12 }}>
                  <div style={{ background:(selectedAnalysis.ats_score||0)>=75?"#f0fdf4":"#fffbeb", borderRadius:8, padding:"6px 12px", textAlign:"center", flexShrink:0 }}>
                    <div style={{ fontSize:20, fontWeight:900, color:(selectedAnalysis.ats_score||0)>=75?"#059669":"#d97706" }}>{selectedAnalysis.ats_score||0}</div>
                    <div style={{ fontSize:9, color:"#64748b", fontWeight:600 }}>ATS</div>
                  </div>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700, color:"#1e40af" }}>
                      Analysis #{analyses.findIndex(a=>a.id===selectedAnalysis.id)!==-1 ? analyses.length-analyses.findIndex(a=>a.id===selectedAnalysis.id) : 1} selected
                    </div>
                    <div style={{ fontSize:11, color:"#3b82f6", marginTop:2 }}>
                      {selectedAnalysis.missing_keywords?.length||0} keywords to inject · {selectedAnalysis.match_rate||0}% match rate
                    </div>
                  </div>
                </div>
              )}

              <div style={{ background:"#fff", border: resumeText?"2px solid #86efac":"1.5px solid #e2e8f0", borderRadius:14, overflow:"hidden", marginBottom:16, transition:"border-color 0.2s" }}>
                <div style={{ padding:"14px 18px", background: resumeText?"linear-gradient(135deg,#f0fdf4,#ecfdf5)":"#fafaf9", borderBottom:"1px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"center", flexWrap:"wrap", gap:10 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                    <div style={{ width:34, height:34, borderRadius:9, background: resumeText?"#dcfce7":"#eff6ff", display:"flex", alignItems:"center", justifyContent:"center", fontSize:16 }}>
                      {resumeText ? "✅" : "📄"}
                    </div>
                    <div>
                      <div style={{ fontWeight:700, fontSize:13, color:"#0f172a" }}>
                        {resumeText ? `Resume ready (${resumeText.split(" ").length} words)` : "Your Resume"}
                      </div>
                      <div style={{ fontSize:11, color: resumeText?"#059669":"#94a3b8" }}>
                        {resumeText ? "AI will use this as the base and improve it" : "Upload or paste — AI will preserve your real data"}
                      </div>
                    </div>
                  </div>
                  <div style={{ display:"flex", background:"#f1f5f9", borderRadius:8, padding:3, gap:2 }}>
                    {[{id:"upload",label:"📎 Upload"},{id:"paste",label:"✏️ Paste"}].map(m=>(
                      <button key={m.id} onClick={()=>setUploadMode(m.id)}
                        style={{ padding:"5px 12px", borderRadius:6, border:"none", fontSize:11, fontWeight:600, cursor:"pointer", background: uploadMode===m.id?"#fff":"transparent", color: uploadMode===m.id?"#1e293b":"#64748b", boxShadow: uploadMode===m.id?"0 1px 3px rgba(0,0,0,0.08)":"none" }}
                      >{m.label}</button>
                    ))}
                  </div>
                </div>
                <div style={{ padding:"14px 18px" }}>
                  {uploadMode==="upload" ? (
                    <div
                      onClick={()=>fileRef.current.click()}
                      style={{ border:`2px dashed ${resumeText?"#86efac":"#cbd5e1"}`, borderRadius:10, padding:"24px 16px", textAlign:"center", cursor:"pointer", background: resumeText?"#f0fdf4":"#f8fafc", transition:"all 0.2s" }}
                      onMouseEnter={e=>{ if (!resumeText){e.currentTarget.style.borderColor="#93c5fd";e.currentTarget.style.background="#eff6ff";} }}
                      onMouseLeave={e=>{ if (!resumeText){e.currentTarget.style.borderColor="#cbd5e1";e.currentTarget.style.background="#f8fafc";} }}
                      onDragOver={e=>e.preventDefault()}
                      onDrop={e=>{e.preventDefault();const f=e.dataTransfer.files[0];if(f)handleFileUpload({target:{files:[f]}});}}
                    >
                      {resumeText ? (
                        <>
                          <div style={{ fontSize:24, marginBottom:8 }}>✅</div>
                          <div style={{ fontWeight:700, color:"#059669", fontSize:14, marginBottom:4 }}>{resumeFileName||"Resume loaded"}</div>
                          <div style={{ fontSize:12, color:"#64748b", marginBottom:8 }}>{resumeText.split(" ").length} words</div>
                          <button onClick={e=>{e.stopPropagation();setResumeText("");setResumeFileName("");}}
                            style={{ fontSize:11, color:"#64748b", background:"#f1f5f9", border:"none", borderRadius:7, padding:"4px 12px", cursor:"pointer" }}>
                            ✕ Replace
                          </button>
                        </>
                      ) : (
                        <>
                          <div style={{ fontSize:28, marginBottom:8 }}>📁</div>
                          <div style={{ fontWeight:700, fontSize:13, color:"#0f172a", marginBottom:4 }}>Drop your resume here</div>
                          <div style={{ fontSize:12, color:"#94a3b8" }}>or click to browse · .docx, .txt</div>
                        </>
                      )}
                      <input ref={fileRef} type="file" accept=".doc,.docx,.txt" style={{ display:"none" }} onChange={handleFileUpload} />
                    </div>
                  ) : (
                    <textarea
                      style={{ width:"100%", height:160, resize:"vertical", fontSize:13, padding:"12px", border:`1.5px solid ${resumeText?"#86efac":"#e2e8f0"}`, borderRadius:10, fontFamily:"inherit", lineHeight:1.6, outline:"none", color:"#1e293b", boxSizing:"border-box", background: resumeText?"#f0fdf4":"#fff" }}
                      placeholder="Paste your full resume text here..."
                      value={resumeText}
                      onChange={e=>setResumeText(e.target.value)}
                    />
                  )}
                  {fileError && <div style={{ fontSize:12, color:"#dc2626", marginTop:6 }}>⚠️ {fileError}</div>}
                </div>
              </div>

              <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"10px 14px", display:"flex", alignItems:"center", gap:8 }}>
                <span style={{ fontSize:14, flexShrink:0 }}>💡</span>
                <span style={{ fontSize:12, color:"#1e40af", lineHeight:1.5 }}>
                  After selecting your template, you'll fill in additional details like skills and certifications on the resume generation page.
                </span>
              </div>
            </div>
          )}

          {/* STEP 3: Template */}
          {step===3 && (
            <div>
              <div style={{ background:"#f8fafc", borderRadius:10, padding:"12px 16px", marginBottom:18, border:"1px solid #e2e8f0", display:"flex", gap:16, flexWrap:"wrap" }}>
                <div style={{ fontSize:12 }}>
                  <span style={{ color:"#64748b" }}>Analysis: </span>
                  <strong style={{ color:"#0f172a" }}>Score {selectedAnalysis?.ats_score||0}</strong>
                  <span style={{ color:"#94a3b8" }}> · {selectedAnalysis?.missing_keywords?.length||0} keywords to inject</span>
                </div>
                <div style={{ fontSize:12 }}>
                  <span style={{ color:"#64748b" }}>Resume: </span>
                  <strong style={{ color:"#059669" }}>{resumeText.split(" ").length} words ✓</strong>
                </div>
              </div>

              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(145px,1fr))", gap:12 }}>
                {templates.map(t => (
                  <TemplateCard key={t.id} template={t} selected={selectedTemplate===t.id} onSelect={setSelectedTemplate} />
                ))}
              </div>

              {activeTemplate && (
                <div style={{ marginTop:14, padding:"12px 16px", background:`${activeTemplate.accent}10`, borderRadius:10, border:`1px solid ${activeTemplate.accent}25`, display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ width:10, height:10, borderRadius:"50%", background:activeTemplate.accent, flexShrink:0 }} />
                  <span style={{ fontSize:13, color:activeTemplate.accent, fontWeight:600 }}>
                    {activeTemplate.name} · {activeTemplate.description}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ padding:"14px 24px", borderTop:"1px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"center", background:"#fff" }}>
          <button
            onClick={()=> step<=(analyses.length>1?1:2) ? onClose() : setStep(s=>s-1)}
            style={{ padding:"10px 18px", background:"transparent", color:"#64748b", border:"1px solid #e2e8f0", borderRadius:10, fontWeight:600, fontSize:13, cursor:"pointer" }}
          >
            {step<=(analyses.length>1?1:2) ? "Cancel" : "← Back"}
          </button>

          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <span style={{ fontSize:12, color:"#94a3b8" }}>Step {currentStepIndex+1} of {totalSteps}</span>

            {step<(analyses.length>1?3:3) ? (
              <button
                onClick={()=>{
                  if (step===2 && !resumeText.trim()) { setFileError("Please provide your resume text before continuing."); return; }
                  setStep(s=>s+1);
                }}
                disabled={step===1 && !selectedAnalysisId}
                style={{ padding:"10px 20px", background:(step===1&&!selectedAnalysisId)?"#e2e8f0":"linear-gradient(135deg,#2563eb,#1d4ed8)", color:(step===1&&!selectedAnalysisId)?"#94a3b8":"#fff", border:"none", borderRadius:10, fontWeight:700, fontSize:13, cursor:(step===1&&!selectedAnalysisId)?"not-allowed":"pointer" }}
              >
                Next →
              </button>
            ) : (
              <button
                onClick={handleGenerate}
                disabled={!resumeText.trim()}
                style={{ padding:"10px 22px", background: resumeText.trim()?`linear-gradient(135deg,${activeTemplate?.accent||"#059669"},${activeTemplate?.headerBg||"#047857"})`:"#e2e8f0", color: resumeText.trim()?"#fff":"#94a3b8", border:"none", borderRadius:10, fontWeight:700, fontSize:13, cursor: resumeText.trim()?"pointer":"not-allowed", boxShadow: resumeText.trim()?`0 4px 14px ${activeTemplate?.accent||"#059669"}40`:"none", display:"flex", alignItems:"center", gap:8 }}
                onMouseEnter={e=>{ if(resumeText.trim()) e.currentTarget.style.transform="translateY(-1px)"; }}
                onMouseLeave={e=>e.currentTarget.style.transform="translateY(0)"}
              >
                ✨ Generate My Resume
              </button>
            )}
          </div>
        </div>
      </div>
      <style>{`@keyframes fadeIn { from { opacity:0; transform:scale(0.97); } to { opacity:1; transform:scale(1); } }`}</style>
    </div>
  );
}
